import { Alert, Badge, Button, Card, Col, Input, Row, Space, Table } from 'antd';
import { useState } from 'react';
import { cachedBcpEventService } from '../../services/CachedBcpEventService';

function ListChecker() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();

  const [players, setPlayers] = useState([]);

  // const [round, setRound] = useState(1);

  const [eventCode, setEventCode] = useState(undefined);

  const retrieveData = async () => {
    setIsLoading(true);
    setError(undefined);

    try {
      const players = await cachedBcpEventService.getEventPlayers(eventCode, true);

      let tasks = [];
      players.data.forEach((player, i) => {
        const delay = 11500 * i;
        if (player.listId === undefined) {
          return;
        }
        tasks.push(
          new Promise(function (resolve) {
            // the timer/delay
            setTimeout(async () => {
              // the promise you want delayed
              // (for example):
              // let result = await axios.get(...);
              const list = await cachedBcpEventService.getArmyList(player.listId);
              const result = { ...player, list: list };
              
              //resolve outer/original promise with result
              resolve(result);
            }, delay);
          })
        );
      });

      let results = Promise.all(tasks);

      setPlayers(results);

      setIsLoading(false);
    } catch (error) {
      setError(error);
      console.error(error);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Row>
        <Col span={18}>
          <Row gutter={8}>
            <Col span={8}>
              <Space>
                <Input placeholder={'Event Code'} onChange={(e) => setEventCode(e.target.value)}></Input>
                <Button
                  name={'Get Lists'}
                  loading={isLoading}
                  onClick={() => {
                    retrieveData();
                  }}
                >
                  Get Lists{' '}
                </Button>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
      {error && <Alert message={`${error.message}`} type='error' showIcon style={{ marginTop: 16 }} />}
      <Row style={{ paddingTop: '16px' }} gutter={16}>
        <Col span={10}>
          <Card
            title={
              <Space>
                Players
                <Badge count={players?.length || 0} overflowCount={999} style={{ backgroundColor: '#1677ff' }} />
              </Space>
            }
            bodyStyle={{ padding: 0 }}
            type={'inner'}
          >
            <Table
              columns={[
                {
                  title: 'Player',
                  dataIndex: ['user'],
                  key: 'firstName',
                  render: (text, record) => {
                    return `${record.user.firstName} ${record.user.lastName}`;
                  },
                  width: '250px',
                },
                {
                  title: 'Army',
                  dataIndex: ['faction', 'name'],
                  key: 'army',
                },
                {
                  title: 'Created At',
                  dataIndex: ['list', 'created_at'],
                  key: 'Created',
                },
                {
                  title: 'Updated At',
                  dataIndex: ['list', 'updated_at	'],
                  key: 'updated_at	',
                },
                {
                  title: 'List',
                  key: 'listId',
                  dataIndex: 'listId',
                  width: '65px',
                  render: (text) => {
                    return (
                      <a target='_BLANK' href={`https://bestcoastpairings.com/list/${text}`} rel='noreferrer'>
                        List
                      </a>
                    );
                  },
                },
              ]}
              dataSource={players}
              loading={isLoading}
              rowClassName={(record, _index) => {
                return record.name === 'Netherlands' ? 'own-team-row' : '';
              }}
              rowKey={'playerId'}
              size='small'
              // onRow={(team) => ({
              //   onClick: () => {
              //     setSelectedTeam(team);
              //   },
              // })}
              // rowSelection={{
              //   type: 'radio',
              //   selectedRowKeys: [selectedTeam?.playerId],
              //   onSelect: (team) => {
              //     setSelectedTeam(team);
              //   },
              // }}
              pagination={{ defaultPageSize: '50', pageSizeOptions: ['25', '50', '100', '200'] }}
            ></Table>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default ListChecker;
